export default __webpack_public_path__ + "static/PODSTAWOWA codeme_logo_black_red_subtitle_black_rgb-e9c2960595ed86d2acd7fcab76b67376.png";